import { parseIfJSON } from '@/utils';
import { Stack, Typography } from '@mui/material';
import { Popup } from 'react-map-gl/maplibre';
import { Status } from './Status';

export function VehiclePopup({
  hoverInfo: {
    longitude,
    latitude,
    feature: { properties },
  },
}) {
  const vehicle = properties.vehicle ? parseIfJSON(properties.vehicle) : null;
  const driver = properties.driver ? parseIfJSON(properties.driver) : null;
  const lastDriver = properties.lastDriver
    ? parseIfJSON(properties.lastDriver)
    : null;

  return (
    <Popup
      longitude={longitude}
      latitude={latitude}
      offset={[0, -16]}
      closeButton={false}
    >
      <Stack spacing={1}>
        <Typography variant="subtitle2">
          {vehicle?.registrationNumber ?? properties.imei}
        </Typography>
        <Status status={properties.status} />
      </Stack>
    </Popup>
  );
}
